import React, { Component } from 'react'

import style from './Grid.css'

export default class Container extends Component {
  render() {
    return (
      <div
        style={{
          ...this.props.style
        }}
        className={`${style.Container} ${(this.props.full) ? style.full : ''} ${this.props.className || ''}`}
      >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Footer/Grid/Container.js